import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import format from 'date-fns/format';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import BookCoverImage from 'rebook/apps/books/components/BookCoverImage';
import BookRating from 'rebook/apps/books/components/BookRating';
import BookReadButton from 'rebook/apps/books/components/BookReadButton';
import BookReadButtonNonRent from 'rebook/apps/books/components/BookReadButtonNonRent';
import BookAuthor from 'rebook/apps/books/components/BookAuthor';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import pluralize from 'rebook/apps/utils/text/pluralize';
import { StandardBtn, PremiumBtn, FreeBtn } from 'rebook/apps/base/components/BtnSubscriptionIcon';
import AppButton from 'rebook/apps/base/components/AppButton';
import { Book } from 'rebook/apps/books/models';
import AuthForm from 'rebook/mybook/App/AuthForm';
import { showForm } from 'rebook/apps/users/actions/AuthFormActions';
import BookStatusChangeButton from 'rebook/apps/books/components/BookStatusChangeButton';
import BookStatusShield from 'rebook/apps/books/components/BookStatusShield';
import BookRightholder from 'rebook/apps/books/components/BookRightholder';
import SocialShareMenu from 'rebook/apps/base/components/SocialShareMenu';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';
import Button from 'rebook/apps/base/components/Button';
import { pop } from 'rebook/apps/users/actions/NotificationActions';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import { parseApiDateTime, formatDateTime } from 'rebook/apps/utils/datetime';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';

import BookPageHeaderUserRating from '../BookPageHeaderUserRating';
import styles from './style.scss';


class BookPageHeaderContent extends React.Component {
  constructor(props) {
    super(props);
    this.userAgent = navigator && navigator.userAgent ? navigator.userAgent : null;
    this.state = {
      isOpenedModalWIndow: false,
      readingStatus: get(this.props.book, 'reading_status', null),
      changedBookStatusText: 'Удалить из Моих книг',
      isChangedBookStatus: false,
    };
    this.isPendingChangeBookStatus = false;
  }

  componentDidMount() {
    setTimeout(function () {
      window.dataLayer.push({ event: 'optimize.rent.activate' });
    }, 0);
  }

  componentDidUpdate({ book }) {
    const { book: currentBook } = this.props;

    if (book.reading_status !== currentBook.reading_status || book.id !== currentBook.id) {
      this.setState({
        readingStatus: this.props.book.reading_status,
      });
    }
  }

  onChangeStatus(status) {
    this.setState({ readingStatus: status });
  }

  openAttentionWindow() {
    this.setState({
      isOpenedModalWIndow: true,
    });
  }

  closeAttentionWindow() {
    this.setState({
      isOpenedModalWIndow: false,
    });
  }

  onRemoveStatus() {
    const { book } = this.props;
    const isAudioBook = book.type === 'audio';
    const popupMessage = {
      message: `${isAudioBook ? 'Аудиокнига' : 'Книга'} ${book.name} удалена из Моих книг`,
      type: 'removed',
    };
    this.isPendingChangeBookStatus = true;
    const url = `/api/books/${book.id}/remove-from-books/`;
    const params = {
      apiVersion: 4,
      method: 'DELETE',
    };
    fetchQuery(url, params).then(() => {
      const { message, type } = popupMessage;
      this.props.pop(message, type);
      ga('send', 'event', 'DeleteFromMyBooks');
    }).then(() => {
      this.isPendingChangeBookStatus = false;
      this.setState({
        changedBookStatusText: 'Книга удалена из Моих книг',
        isChangedBookStatus: true,
      });
    }).catch(() => {
      this.isPendingChangeBookStatus = false;
      this.setState({
        changedBookStatusText: 'Книга удалена из Моих книг',
        isChangedBookStatus: true,
      });
    });
  }

  getModalWindow(isAudioBook = false) {
    const bookText = isAudioBook ? 'Аудиокнига' : 'Книга';
    const booksText = isAudioBook ? 'аудиокнигу' : 'книгу';
    return (
      <ModalDialog
        fullSizeForSmall
        extraClassname={styles.modalWindowContainer}
        onClose={() => {
          this.closeAttentionWindow();
        }}
        dialog={
          {
            id: '1',
            content:
              <div className={classNames(styles.unavailableInformationWindow, 'jest-unavailable-book-modal-window')}>
                <div className={styles.modalWindowHeader}>
                  <div className={styles.modalWindowHeaderText}>
                    <span>
                      {bookText} {isAudioBook ? <br /> : ''}пропала {!isAudioBook ? <br /> : ''}
                      из {isAudioBook ? <br /> : ''}MyBook по одной {isAudioBook ? <br /> : ''}
                      из этих причин
                    </span>
                  </div>
                  <div className={styles.modalWindowHeaderImage} />
                </div>
                <div className={styles.unavailableInformationWindowCausesList}>
                  <div className={styles.unavailableCauseItem}>
                    <div className={styles.endedContractImage} />
                    <span className={styles.unavailableCauseItemText}>
                    Закончился срок договора<br /> с правообладателем.
                    </span>
                  </div>
                  <div className={styles.unavailableCauseItem}>
                    <div className={styles.rightsMovedImage} />
                    <span className={styles.unavailableCauseItemText}>
                    Права на {booksText} перешли к другому издательству.
                    </span>
                  </div>
                </div>
                <div className={styles.unavailableInformationWindowTitle}>
                  <span>
                  Мы&nbsp;уже работаем над тем, чтобы {bookText.toLowerCase()} вернулась.
                  Но&nbsp;решение остается на&nbsp;усмотрение автора или издателя.
                  </span>
                </div>
              </div>,
          }
        } />
    );
  }

  render() {
    const { user, hideControls, pageType, bookDetail } = this.props;
    const { readingStatus, isOpenedModalWIndow } = this.state;
    const book = new Book(this.props.book);
    const connectedBook = (this.props.connectedBook && get(this.props.connectedBook, 'type', null) !== book.type)
      ? new Book(this.props.connectedBook)
      : null;

    const subscriptionIconList = [
      null,
      <StandardBtn width="28" height="28" />,
      <PremiumBtn width="32" height="32" />,
      <PremiumBtn width="32" height="32" />,
    ];

    const isForAnonymous = !user;
    const isUserWithAudio = !!get(user, 'subscription_audio_active_till', null);
    const isUnavailable = !book.available && !book.available_for_user;
    const isUnavailableBookNoPreview = !book.available_for_user && !book.preview;
    const BtnSubscriptionIcon = subscriptionIconList[book.subscription_id] || <FreeBtn />;
    const isAudioBook = book.type === 'audio';
    const isFragmentAvailable = !user && !!book.available && book.preview && pageType !== 'fragment' && !isAudioBook;
    const isConnectedBookAvailable = connectedBook && pageType !== 'fragment';
    const isAddedToReadingList = get(book, 'reading_status', null);

    /**
     * Проверяем доступна ли книга конкретному пользователю {available_for_user_only}.
     * Если она доступна и есть дата окончания доступности {available_for_user_till},
     * то показываем плашку "Недоступна с {дата}".
     * Поле {available_for_user_till} приходит из апи только когда у пользователя есть,
     * подписка, позволяющая читать эту книгу, если подписка закончилась, то
     * в полях будут следующие значения:
     * available_for_user_only: true,
     * available_for_user_till: null,
     */

    const isAvailableOnlyUser = get(book, 'available_for_user_only', false);
    const availableTill = get(book, 'available_for_user_till', null);
    const attentionText = isAvailableOnlyUser && availableTill
      ? `Недоступна с ${formatDateTime(parseApiDateTime(availableTill), 'DD.MM.YYYY')}`
      : null;
    const modalWindow = this.getModalWindow(isAudioBook);
    let isFullAvailableBookInfo = !!('available' in book && 'available_for_user' in book);
    const isAvailableForReadingInRent = book.is_available_for_reading_in_rent;
    const rentValidTill = format(book.rent_valid_till, 'DD.MM.YYYY');
    const isRented = book.is_rented;
    const isUserHasSubscription = user && !!user.active_subscription_type;
    const isAvailableForRent = book.available_for_rent;
    const isAudioBookAvailableForRent = isAudioBook && isAvailableForRent || isAvailableForReadingInRent;
    const isAvailableForRentForAnonymousUser = !user && book.rent_product && book.rent_product.is_active;
    const isUserHasNeededSubscription = isUserHasSubscription
      && (user.active_subscription_type === 'audio'
        || (user.active_subscription_type === 'standard' && book.subscription_id === 1));
    return (
      <div key={book.id}>
        {isOpenedModalWIndow && modalWindow}
        {isUserHasNeededSubscription ? null : (isRented ? (isAvailableForReadingInRent
          ? <div className={styles.rentTimeBlock}>Книга в аренде до {rentValidTill}</div>
          : <div className={styles.rentTimeBlockEnd}>Аренда закончилась {rentValidTill}</div>
        ) : null)
        }
        <div className={styles.cover}>

          {(attentionText && !isUnavailable) && (
            <div className={styles.bookAvailableAttentionText}>
              <span>
                {attentionText}
              </span>
            </div>
          )}

          {(isFullAvailableBookInfo && isUnavailable) && (
            <div className={classNames(styles.bookAvailableAttentionText, 'jest-unavailable-header-text')}>
              <span>{isAudioBook ? 'Аудиокнига' : 'Книга'} недоступна</span>
            </div>
          )}

          <div className={styles.coverBackground}>
            <div className={styles.coverBackgroundImage}>
              <CroppedImage
                width={320}
                height={120}
                className={styles.image}
                src={book.default_cover}
                alt={book.name} />
            </div>
          </div>
          <div className={styles.coverContent}>
            <div className={styles.coverInformation}>
              {!!readingStatus && (
                <BookStatusShield
                  type={isAudioBook ? 'audio' : 'text'}
                  readingStatus={readingStatus}
                  extraClassName={styles.bookStatus} />
              )}
              <h1 className={styles.coverTitle}>
                {pageType === 'fragment'
                  ? <Link to={{ pathname: book.absolute_url, state: { book } }}>{book.name}</Link>
                  : <span>{book.name}</span>
                }
              </h1>
              <React.Fragment>
                {get(book, 'authors.length', 0) > 0 && (
                  <BookAuthor book={book} />
                )}
              </React.Fragment>
              <div className={styles.coverTag}>{BtnSubscriptionIcon}</div>
            </div>
            <div className={classNames(
              styles.coverBlockImage,
              { [styles.coverBlockImageAudio]: isAudioBook },
            )}>
              <BookCoverImage book={book} />
            </div>
          </div>
        </div>
        <div className="themeWhite">
          <div className={styles.bookContent}>
            <div className={styles.bookInformation}>
              <div className={styles.bookInformationRating}>
                <div
                  className={styles.bookRating}
                  itemProp="aggregateRating"
                  itemScope
                  itemType="http://schema.org/AggregateRating">
                  <React.Fragment>
                    <meta itemProp="ratingCount" content={book.rating.votes} />
                    <meta itemProp="ratingValue" content={book.rating.rating} />
                    <meta itemProp="bestRating" content="5" />
                    <meta itemProp="worstRating" content="0" />
                    <div itemProp="itemReviewed" itemScope itemType="http://schema.org/Product" />
                  </React.Fragment>
                  <BookRating value={book.rating.rating} />
                  <span className={styles.bookRatingCount}>
                    {book.rating.rating.toPrecision(2).replace('.', ',')}
                  </span>
                </div>
                <div className={styles.bookReaderCount}>
                  {book.rating.votes || 0}&nbsp;
                  {pluralize(book.rating.votes, 'читатель оценил', 'читателя оценили', 'читателей оценили')}
                </div>
              </div>

              <div className={classNames(styles.bookStatistic, isAudioBook && 'isAudioBook',)}>
                {book.character_count > 0 && (
                  <div className={styles.bookStatisticItem}>
                    {Math.floor(book.character_count / 1800)} печ. страниц
                  </div>
                )}
                {book.seconds > 0 && (
                  <React.Fragment>
                    <div className={styles.bookStatisticItem}>
                      {this.renderAudioobookTiming(book.seconds)}
                    </div>
                  </React.Fragment>
                )}
                {book.bytes > 0 && (
                  <div className={styles.bookStatisticItem}>
                    {this.renderAudioobookSize(book.bytes)}
                  </div>
                )}
                {Boolean(book.partner_planned_dt) && (
                  <React.Fragment>
                    <div className={styles.bookStatisticItem}>
                      {book.partner_planned_dt.slice(0, 4)} год
                    </div>
                  </React.Fragment>
                )}
              </div>
              {(isFragmentAvailable || isConnectedBookAvailable)
                ? (
                  <dir className={classNames(
                    styles.relatedLinks,
                    isAudioBook && 'isAudioBook',
                  )}>
                    {isFragmentAvailable && (
                      <div className={styles.relatedLinksItem}>
                        <i className={classNames(styles.relatedLinksIcon, styles.relatedLinksIconFragment)} />
                        <Link to={book.getFragmentUrl()} className={styles.readFragment}>
                          {isForAnonymous ? 'Читать отрывок онлайн' : 'Читать отрывок'}
                        </Link>
                      </div>
                    )}
                    {isConnectedBookAvailable && (
                      <div className={styles.relatedLinksItem}>
                        <i className={classNames(
                          styles.relatedLinksIcon,
                          !isAudioBook ? [styles.relatedLinksIconAudio] : [styles.relatedLinksIconFragment],
                        )} />
                        <Link to={connectedBook.getLink()} className={styles.readFragment}
                          onClick={() => {
                            ga('send', 'event', {
                              eventCategory: isAudioBook ? 'AudioBook' : 'BookCard',
                              eventAction: 'PressButton',
                              eventLabel: isAudioBook ? 'GoToBook' : 'GoToAudioBook',
                            });
                          }}>
                          {`Есть ${isAudioBook ? 'электронная версия' : 'аудиоверсия'}`}
                          <i className="shortArrow" style={{ marginLeft: '8px' }} />
                        </Link>
                      </div>
                    )}
                  </dir>
                )
                : (
                  <dir className={styles.relatedLinksEmpty} />
                )
              }
            </div>
            <div className={styles.rightHolderContainer}>
              <BookRightholder book={book} user={user} />
              <div className={styles.shareLinks}>
                <SocialShareMenu
                  url={book.share_url}
                  utmCampaign={book.type === 'audio' ? 'audio' : 'book'}
                  imageUrl={book.default_cover} />
              </div>
            </div>
          </div>

          {!hideControls && (
            <div className={styles.bookContent}>
              <div
                className={classNames(styles.booksButtons, { isForAnonymous }, { isUnavailable }, { isAudioBook })}
                suppressHydrationWarning>
                {!isAvailableForRentForAnonymousUser &&
                !isAudioBookAvailableForRent &&
                isAudioBook &&
                !isUnavailable &&
                (isForAnonymous || !isUserWithAudio) &&
                this.renderOffer()}
                <div className={classNames(styles.booksButtonBlock, { isForAnonymous })}>
                  {isAudioBook && !!book.available && this.renderAudioBookControls(
                    book,
                    isForAnonymous,
                    bookDetail,
                    isAudioBookAvailableForRent,
                    isRented,
                    isAvailableForRent,
                    isAvailableForReadingInRent)}
                  {!isAudioBook && !!book.available &&
                  this.renderTextBookControls(
                    user, book, isForAnonymous,
                    isUnavailableBookNoPreview,
                    bookDetail,
                    isRented,
                    isAvailableForRentForAnonymousUser,
                    isUserHasSubscription,
                    isAvailableForReadingInRent,
                    isUserHasNeededSubscription,
                  )
                  }
                </div>
                {(availableTill && !isUnavailable) && (
                  <div className={styles.bookAvailableAttention}>
                    <span className={styles.attentionAvailableText}>
                      Книга станет недоступна {formatDateTime(parseApiDateTime(availableTill), 'DD.MM.YYYY')}
                    </span>
                    <div className={styles.bookAttentionTillImage} />
                  </div>
                )}
                {isUnavailable && (
                  <div
                    className={styles.bookAvailableAttention}>
                    <div className={styles.linkContainer} onClick={() => {
                      this.openAttentionWindow();
                    }}>
                      <span className={classNames(styles.attentionAvailableText, 'jest-unavailable-title-block')}>
                        <span>{isAudioBook ? 'Аудиокнига' : 'Книга'} недоступна</span>
                        <span className={classNames(styles.unavailableInfoText, 'link')}>Узнать, почему</span>
                      </span>
                      <div className={styles.unavailableBookAttentionImage} />
                    </div>
                    {isAddedToReadingList && (
                      <div className={styles.changeBookStatusButtonContainer}>
                        <Button
                          handleClick={() => this.onRemoveStatus(0)}
                          extraClassName={classNames(styles.buttonDisable, 'jest-change-unavailable-book-status')}
                          size="small"
                          theme="secondary"
                          isDisabled={this.state.isChangedBookStatus}
                          isInProgress={this.isPendingChangeBookStatus}>
                          {this.state.changedBookStatusText}
                        </Button>
                      </div>
                    )}
                  </div>
                )}
                <div className={classNames(styles.bookUserRating, 'jest-user-rating')}>
                  {!user && (
                    <div className={styles.bookUserRatingOverlay} onClick={this.props.showForm} />
                  )}
                  <BookPageHeaderUserRating book={book} />
                  <div className={styles.bookUserRatingText}>
                    Оцените книгу
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderAudioobookTiming(seconds) {
    let result = '';
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    if (hours > 0) {
      result = `${hours} ${hours > 1 ? 'час.' : 'час'}`;
    }
    if (mins > 0) {
      result += ` ${mins} мин.`;
    }
    return result;
  }

  renderAudioobookSize(bytes) {
    return (bytes / 1024) > 1024 ? `${Math.floor(bytes / (1024 * 1024))} Мб` : `${Math.floor(bytes / 1024)} Кб`;
  }

  renderTextBookControls(
    user,
    book,
    isForAnonymous,
    isUnavailableBookNoPreview,
    bookDetail,
    isRented,
    isAvailableForRentForAnonymousUser,
    isUserHasSubscription,
    isAvailableForReadingInRent,
    isUserHasNeededSubscription,) {
    const isAudioBook = book.type === 'audio';
    const isAvalibleForRent = book.available_for_rent;
    return (
      <React.Fragment>
        {user
          ? (
            <div className={styles.bookReadButtons}>
              <BookReadButton
                book={book}
                extraClassName={classNames(styles.readBtn, styles.readBtnRent, 'jest-read-reader-link-rent')}
                GACategory="BookCard"
                isRented={isRented}
                isAvalibleForRent={isAvalibleForRent}
                isReaderUnavailable={isUnavailableBookNoPreview}
                isUserHasSubscription={isUserHasSubscription}
                isAvailableForReadingInRent={isAvailableForReadingInRent}
                isUserHasNeededSubscription={isUserHasNeededSubscription}>
                {isRented
                  ? 'Продолжить читать'
                  : (isAvalibleForRent
                    ? 'Начать читать'
                    : (isUnavailableBookNoPreview
                      ? 'Купить и читать'
                      : 'Читать онлайн'))
                }
              </BookReadButton>

              <BookReadButtonNonRent
                book={book}
                extraClassName={classNames(styles.readBtn, styles.readBtnRead, 'jest-read-reader-link')}
                GACategory="BookCard"
                isReaderUnavailable={isUnavailableBookNoPreview}>
                {isUnavailableBookNoPreview
                  ? 'Купить и читать'
                  : 'Читать онлайн'
                }
              </BookReadButtonNonRent>
              {this.renderStatusChangeButton(book, user, bookDetail)}
            </div>
          )
          : (
            <React.Fragment>
              <div className={classNames(styles.registrationForm, styles.readBtnUnknownLogin)}>
                <AuthForm
                  redirectUrl={book.getReaderUrl()}
                  type="tinyRegistration" />
              </div>
              <div className={styles.bookReadButtons}>
                <BookReadButton
                  book={book}
                  extraClassName={classNames(
                    styles.readBtn,
                    styles.readBtnUnknownRead,
                    'jest-read-reader-link-rent-unknown')}
                  GACategory="BookCard"
                  unknownUser
                  isAvailableForRentForAnonymousUser={isAvailableForRentForAnonymousUser}
                  isAvalibleForRent={isAvalibleForRent}
                  isReaderUnavailable={isUnavailableBookNoPreview}>
                  Начать читать
                </BookReadButton>
              </div>
            </React.Fragment>
          )
        }
        <div className={classNames(styles.appLink, { isForAnonymous })}>
          <AppButton target={`bookpage${isAudioBook ? '_audio' : ''}`} suppressHydrationWarning />
        </div>
      </React.Fragment>
    );
  }

  renderAudioBookControls(
    book,
    hideStatusChange,
    bookDetail,
    isAudioBookAvailableForRent,
    isRented) {
    const { user, showPlayer } = this.props;
    return (
      <React.Fragment>
        <div className={styles.readBtnRent}>
          <div className={styles.audioWrapper}>
            <div className={styles.buttonWrapper}>
              <Button
                extraClassName={classNames('jest-listen-link', 'cy-show-player-button-1')}
                handleClick={() => {
                  const availableForUser = !!get(book, 'available_for_user', null);
                  const eventLabel = (user && availableForUser) ? 'Listen' : 'ListenTrial';
                  showPlayer();
                  yaMetrikaReachGoal(eventLabel);
                  ga('send', 'event', {
                    eventCategory: 'BookCard',
                    eventAction: 'PushButton',
                    eventLabel,
                  });
                }}>
                Начать слушать
              </Button>
              {!hideStatusChange && this.renderStatusChangeButton(book, user, bookDetail)}
            </div>
            <AppButton
              target="bookpage_audio"
              extraClassName={classNames(styles.appButton, 'jest-app-buton')}
              isAudio />
          </div>
        </div>
        <div className={styles.readBtnRead}>
          <div className={styles.audioWrapper}>
            <div className={styles.buttonWrapper}>
              <Button
                extraClassName={classNames('jest-listen-link', 'cy-show-player-button-2')}
                handleClick={() => {
                  showPlayer();
                  ga('send', 'event', {
                    eventCategory: 'BookCard',
                    eventAction: 'PushButton',
                    eventLabel: isRented ? 'ListenTrialAgain' : 'ListenTrial',
                  });
                }}>
                {isRented
                  ? 'Продолжить слушать'
                  : 'Начать слушать'
                }
              </Button>
              {!hideStatusChange && this.renderStatusChangeButton(book, user, bookDetail)}
            </div>
            <AppButton
              target="bookpage_audio"
              extraClassName={classNames(styles.appButton, 'jest-app-buton')}
              isAudio />
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderOffer() {
    const { booksPerSubscriptionCounter } = this.props;
    return (
      <div className={styles.offerContainer}>
        <div className={styles.offerText}>
          <strong>Читать и слушать</strong>&nbsp;
          {numberWithSpace(booksPerSubscriptionCounter.total)} книг
          и {numberWithSpace(booksPerSubscriptionCounter.audio)} аудиокниг
        </div>
        <Button
          size="small"
          link="/trial/?from=bookpage_audio"
          theme="advert">
          14 дней бесплатно
        </Button>
      </div>
    );
  }

  renderStatusChangeButton(book, user, bookDetail) {
    return (
      <BookStatusChangeButton
        user={user}
        book={book}
        bookType={book.type}
        bookId={book.id}
        readingStatus={book.reading_status}
        bookTitle={book.name}
        bookDetail={bookDetail}
        onChangeStatus={(status) => this.onChangeStatus(status)} />
    );
  }
}

BookPageHeaderContent.propTypes = {
  book: PropTypes.shape({
    rating: PropTypes.shape({
      rating: PropTypes.number,
      votes: PropTypes.number,
    }),
    default_cover: PropTypes.string,
    subscription_id: PropTypes.number,
  }),
  pageType: PropTypes.string,
};

BookPageHeaderContent.defaultProps = {
  book: {
    rating: {
      rating: 0,
      votes: 0,
    },
  },
  pageType: 'detail',
};

function mapStateToProps(state) {
  return {
    user: state.user,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookDetailActions: bindActionCreators(BookDetailActions, dispatch),
    showForm: () => dispatch(showForm()),
    pop: (message, type) => dispatch(pop(message, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookPageHeaderContent);
